import Vue from 'vue';
import VueResource from 'vue-resource';
import VueCookie from 'vue-cookie';
import router from '@/router';
import store from '@/store';
import i18n from '@/i18n';
import EventBus from '@/plugins/EventBus';
import backendUrl from '@/util/backendDetection';
import App from './App.vue';

Vue.use(VueResource);
Vue.use(VueCookie);
Vue.use(EventBus);

Vue.http.options.root = `${backendUrl}/api/${process.env.VUE_APP_API_VERSION}/`;

const interceptorProxy = (request) => {
  const token = store.getters.getToken || Vue.cookie.get('token');
  if (token) {
    request.headers.set('Authorization', `Bearer ${token}`);
  }
};

Vue.http.interceptors.unshift(interceptorProxy);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
